import Constants from './Feedbackconstant';

let initialState = {
    loading: true,
    questionsData: [],
    postDataSuccess: {},
    error: {},
    UserLoading : true,
    UserExisting : {},
    UserExistingFailed:{}
};

export default function FeedbackReducer(state = initialState, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Constants.ACTIONS.GET_QUESTIONS_DATA_SUCCESS:
            newState.loading = false;
            newState.questionsData = action.payload;
            break;
        case Constants.ACTIONS.GET_QUESTIONS_DATA_FAILED:
            newState.loading = false;
            newState.error = action.payload;
            break;
        case Constants.ACTIONS.POST_QUESTIONS_DATA_SUCCESS:
            newState.loading = false;
            newState.postDataSuccess = action.payload;
            break;
        case Constants.ACTIONS.POST_QUESTIONS_DATA_FAILED:
            newState.loading = false;
            newState.error = action.payload;
            break;
        case Constants.ACTIONS.GET_USER_EXISTING_SUCCESS:
            newState.UserLoading = false;
            newState.UserExisting = action.payload;
            break;
        case Constants.ACTIONS.GET_USER_EXISTING_FAILED:
            newState.UserLoading = false;
            newState.UserExistingFailed = action.payload;
            break;
        default:
            break;
    }
    return newState;
}